import $ from 'jquery';
import ModalContent from '../components/ModalContent';
import ModalView from '../components/ModalView';

export default class TemplateAccount {
  constructor({ el }) {
    this.$el = $(el);
    this._bindEvents();
    if ($(document.body).hasClass('template-customers-addresses')) { this.prepareAddresses(); }
    if ($(document.body).hasClass('template-customers-login')) { this.checkForReset(); }
    if (window.location.hash === '#recover') { this.recoverPassword(); }
  }

  _bindEvents() {
    this.events = [
      $('.delete-address', this.$el).on('click.account', event => this.deleteAddress(event)),
      $('.edit-address', this.$el).on('click.account', event => this.editAddress(event)),
      $('.cancel-edit', this.$el).on('click.account', event => this.cancelEditing(event)),
      $('.toggle-new-address', this.$el).on('click.account', event => this.toggleNewAddress(event)),
      $('.toggle-forgetfulness span', this.$el).on('click.account', event => this.recoverPassword(event)),
    ];
  }

  _unbindEvents() {
    this.events.forEach($el => $el.off('.account'));
  }

  recoverPassword() {
    $('.recover-password').toggle();
    $('.customer-login').toggle();
  }

  checkForReset() {
    if ($('.reset-check').data('successful-reset') === true) {
      $('.successful-reset').show();
    }
  }

  prepareAddresses() {
    new Shopify.CountryProvinceSelector('address-country', 'address-province', {
      hideElement: 'address-province-container',
    });

    $('.customer-address').each((index, address) => {
      const addressID = $(address).data('address-id');
      new Shopify.CountryProvinceSelector(`address-country-${addressID}`, `address-province-${addressID}`, {
        hideElement: `address-province-container-${addressID}`,
      });
    });
  }

  deleteAddress(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    Shopify.CustomerAddress.destroy(addressID);
  }

  editAddress(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');

    const modalContent = new ModalContent({
      title: false,
      message: false,
    });

    return new ModalView({
      model: modalContent,
      el: $(`.modal-wrapper[data-address-id='${addressID}']`),
    });
  }

  cancelEditing(e) {
    const addressID = $(e.target).parents('[data-address-id]').data('address-id');
    $(`.customer-address[data-address-id='${addressID}']`).removeClass('editing');
    $(`.customer-address-edit-form[data-address-id='${addressID}']`).removeClass('show');
  }

  toggleNewAddress() {
    $('.add-new-address').toggle();
    $('.customer-new-address').toggleClass('show');
  }

  onSectionUnload() {
    this._unbindEvents();
  }
}
